import {
    GET_ALL_BOOKING_LOGS_FAILURE,
    GET_ALL_BOOKING_LOGS_REQUEST,
  GET_ALL_BOOKING_LOGS_SUCCESS,
} from "../../../Utils/Constant";

// Get All Reservation List Details
export const getAllBookingLogsListRequest = (payload) => {
  return {
    type: GET_ALL_BOOKING_LOGS_REQUEST,
    payload,
  };
};

export const getAllBookingLogsListSuccess = (data) => {
  return {
    type: GET_ALL_BOOKING_LOGS_SUCCESS,
    payload: data,
  };
};

export const getAllBookingLogsListFailure = (error) => {
  return {
    type: GET_ALL_BOOKING_LOGS_FAILURE,
    payload: error,
  };
};
